import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
} from 'ramda';
import Input from '../../common/Input';
import Wysisyg from '../../common/Wysisyg';
import '../../css/forms/default-forms.css';
import fields from './fields';
import Breadcrumbs from '../../common/Breadcrumbs';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { saveEmailTemplate } from '../../api/emailTemplate';

export class EmailTemplatesAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(processFields(this.state.fields));
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToEmailTemplates();
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
           { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
           { url: '/pages/emailtemplates', icon: 'email', name: 'Email Templates' },
           { icon: 'add_to_photos', name: 'Add Email Templates' },
          ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Email Template
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    field={this.state.fields['name']}
                    onChange={this.changeFormValue}
                  />
                  <Wysisyg
                    field={this.state.fields['content']}
                    onChange={this.changeFormValue}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveForm: (data) => {
      saveEmailTemplate({ details: JSON.stringify(data) })(dispatch);
    },
    goToEmailTemplates: () => {
      dispatch(push('/pages/emailtemplates'));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplatesAdd);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplatesAdd/index.js